import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import ICU from 'i18next-icu';

i18next.use(ICU).use(initReactI18next);

export const i18n = i18next;
